import { FC, ReactElement } from 'react';

import styles from './GuideModalCard.module.scss';

interface GuideModalCardProps {
  icon: ReactElement;
  text: string;
}

export const GuideModalCard: FC<GuideModalCardProps> = ({
  icon,
  text
}: GuideModalCardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.description}>
        {icon}
        <div className={styles.text}>{text}</div>
      </div>
    </div>
  );
};
